var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UsersView',{attrs:{"id":_vm.profile.id,"view-type":_vm.viewType}})}
var staticRenderFns = []

export { render, staticRenderFns }